"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var ChatSupport = function ChatSupport(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 198 180"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {}, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.481,151.219 L1.305,161.178 L11.482,123.205 C4.472,111.155 0.431,97.155 0.431,82.208 C0.431,37.134 36.972,0.59 82.051,0.59 C127.122,0.59 163.666,37.134 163.666,82.208 C163.666,127.282 127.122,163.828 82.051,163.828 C66.023,163.832 51.091,159.199 38.481,151.219 Z M196.76,176.976 L162.942,167.917 C151.465,175.174 137.885,179.391 123.312,179.391 C112.922,179.391 103.041,177.249 94.064,173.392 C139.128,167.492 174.045,128.865 174.045,82.215 C174.045,68.697 171.086,55.864 165.829,44.289 C185.011,57.716 197.559,79.959 197.559,105.142 C197.559,118.738 193.886,131.472 187.509,142.435 L196.76,176.976 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(50.000000, 28.000000)",
    fill: "#000000"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.9261534,27.9896952 C58.9036583,13.1015754 46.9454957,1.10005118 32.1104583,0.0738483171 C23.7009138,-0.505746507 15.675425,2.34102414 9.53265945,8.0964363 C3.47421611,13.7721986 0,21.7954978 0,30.1096611 C0,34.0373938 3.17306541,37.221254 7.08589865,37.221254 C10.9987319,37.221254 14.1717973,34.0373938 14.1717973,30.1096611 C14.1717973,25.658515 15.9588609,21.53308 19.2027853,18.4942963 C22.4438754,15.4583573 26.6798256,13.9556777 31.1368558,14.2643209 C38.9511849,14.8048019 45.2498402,21.1262969 45.7883685,28.9682504 C46.3325655,36.8884314 41.1548993,43.8876612 33.4780367,45.6115113 C27.2580349,47.0082282 22.914379,52.4329513 22.914379,58.8028051 L22.914379,75.8884071 C22.914379,79.8161398 26.0874445,83 30.0002777,83 C33.9138195,83 37.0861763,79.8161398 37.0854677,75.8884071 L37.0854677,59.3710213 C51.3635535,55.9090979 60.9429799,42.7967428 59.9261534,27.9896952 Z",
    stroke: "#000000"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.949,98.051 C33.647,96.749 31.841,96 30,96 C28.159,96 26.353,96.749 25.051,98.051 C23.749,99.353 23,101.159 23,103 C23,104.848 23.7497,106.654 25.051,107.956 C26.353,109.258 28.159,110 30,110 C31.841,110 33.647,109.258 34.949,107.956 C36.251,106.647 37,104.848 37,103 C37,101.159 36.2503,99.353 34.949,98.051 Z"
  })))));
};
/* eslint-enable */
var _default = ChatSupport;
exports["default"] = _default;